var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#202020"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 75,
    width: 36,
    height: 36,
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSquare);
export default __webpack_public_path__ + "static/media/shape-square.78b543d45a589ae58025a7eb7789f1ee.svg";
export { ForwardRef as ReactComponent };